import { InboxOutlined } from '@ant-design/icons';
import { ValidatorProvider } from '@dofleini/validator';
import { Avatar, Form } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

import { CACHE_KEY_LIST_EXPORT_ENTITIES } from '@/modules/configuration/contants/exportEntities';
import ExportEntitiesApiService from '@/modules/configuration/services/ExportEntitiesApiService';
import { getFromSource } from '@/utils/getImages';
import SelectElementCmp from '@/utils/SelectElementCmp';

import style from './index.less';

const ExportEntitySelect = ({ value, onChange, filters, ...props }) => {
  const currentValue = value && typeof value === 'object' ? value._id : value;
  
  const onRenderItem = useCallback(({ name, address, logo }) => {
    return <div className="flex items-center truncate">
      <div className="mr-2 flex self-start pt-1">
        <Avatar src={getFromSource(logo)} icon={<InboxOutlined/>} shape="square"/>
      </div>
      <div>
        <div className="flex items-center truncate">
          <div className="font-semibold">{name}</div>
        </div>
        <div className="element-contact text-xs truncate">{address}</div>
      </div>
    </div>;
  }, []);
  
  return (
    <>
      <div className={classNames('w-full', style.container)}>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_EXPORT_ENTITIES}
          filters={filters}
          service={ExportEntitiesApiService}
          includeValue={value}
          value={currentValue}
          onChange={onChange}
          customItemRender={onRenderItem}
          sort={{ comercialName: 1 }}
          customMapItem={(v) => ({ ...v, name: `${v.comercialName ? `(${v.comercialName})` : ''} ${v.name || ''}` })}
          queryConfig={{ refetchOnWindowFocus: false }}
        />
      </div>
    </>
  );
};

ExportEntitySelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  showContact: PropTypes.bool,
  filters: PropTypes.object
};

export default memo(ExportEntitySelect);

export const renderExportEntitySelect = ({ formItemProps, field, form }) => {
  
  const rules = field?.required && [{ required: true, message: ValidatorProvider.t('validateMessages.required') }];
  
  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <ExportEntitySelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
